import {sections} from "./sections";

export function hasRoleAccess(id, userRole) {
    let listOfSectionRoles = sections.find(section => section.sectionId === id).rolesList;
    return listOfSectionRoles.includes(userRole);
    // comment pre zapnutie podla roli
    // return true;
}